import React, { useEffect } from 'react';

interface ToastProps {
  message: string;
  type: 'success' | 'error' | 'warning' | 'info';
  onClose: () => void;
  duration?: number;
}

const Toast: React.FC<ToastProps> = ({ message, type, onClose, duration = 5000 }) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, duration);

    return () => clearTimeout(timer);
  }, [duration, onClose]);

  const styles = {
    success: {
      bg: 'bg-green-50',
      border: 'border-green-500',
      icon: 'ri-checkbox-circle-line',
      iconColor: 'text-green-500',
      textColor: 'text-green-800',
    },
    error: {
      bg: 'bg-red-50',
      border: 'border-red-500',
      icon: 'ri-error-warning-line',
      iconColor: 'text-red-500',
      textColor: 'text-red-800',
    },
    warning: {
      bg: 'bg-yellow-50',
      border: 'border-yellow-500',
      icon: 'ri-alert-line',
      iconColor: 'text-yellow-500',
      textColor: 'text-yellow-800',
    },
    info: {
      bg: 'bg-blue-50',
      border: 'border-blue-500',
      icon: 'ri-information-line',
      iconColor: 'text-blue-500',
      textColor: 'text-blue-800',
    },
  };

  const style = styles[type];

  return (
    <div
      className={`fixed top-4 right-4 left-4 md:left-auto md:w-96 ${style.bg} border-l-4 ${style.border} p-4 rounded-lg shadow-lg z-50 animate-slideIn`}
      role="alert"
    >
      <div className="flex items-start">
        <div className="flex-shrink-0">
          <i className={`${style.icon} ${style.iconColor} text-xl`}></i>
        </div>
        <div className="ml-3 flex-1">
          <p className={`text-sm font-medium ${style.textColor}`}>{message}</p>
        </div>
        <button
          onClick={onClose}
          className={`ml-3 flex-shrink-0 ${style.iconColor} hover:opacity-70 transition-opacity`}
          aria-label="Close notification"
        >
          <i className="ri-close-line text-xl"></i>
        </button>
      </div>
    </div>
  );
};

export default Toast;
